import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

export interface ProgressProps extends ComponentProps<'div'> {
  /** 0..1 (se recorta). `null` = sin límite (barra vacía punteada). */
  value: number | null;
  tone?: 'default' | 'warning' | 'destructive';
  label: string;
}

/** Barra de uso vs límite (Mi suscripción). Accesible como `progressbar`. */
export function Progress({ value, tone = 'default', label, className, ...props }: ProgressProps) {
  const pct = value === null ? 0 : Math.max(0, Math.min(1, value)) * 100;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value === null ? undefined : Math.round(pct)}
      className={cn(
        'h-2 w-full overflow-hidden rounded-full bg-muted',
        value === null && 'border border-dashed border-border bg-transparent',
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          'h-full rounded-full transition-[width]',
          tone === 'destructive'
            ? 'bg-destructive'
            : tone === 'warning'
              ? 'bg-warning'
              : 'bg-primary',
        )}
        style={{ width: `${String(pct)}%` }}
      />
    </div>
  );
}
